import React, { useMemo } from 'react';
import uuidv4 from "../../utils/uuidv4";
/**
 * Bronson Heading component.
 * @see https://bronson.vwfs.tools/bluelabel/components/detail/bronson-headings.html
 * @constructor
 */
export function Heading({ id, level = 2, children, testId, ...otherProps }) {
    /**
     * Generate unique id, if prop `id` is not provided to improve accessibility.
     */
    const headingId = useMemo(() => id ?? uuidv4('heading-'), [id]);
    const CustomTagHeadingsLevel = `h${level}`;
    return (React.createElement(CustomTagHeadingsLevel, { id: headingId, ...otherProps, "data-testid": testId }, children));
}
